export function getSeriesName(curve, t) {
    let name
    if (curve.key === "TEMPERATURE") 
        name = (curve.other ? `${t("Other")}` : curve.identifier ? `${curve.system} - ${curve.location} - ${curve.identifier.slice(-4)}` : curve.system || curve.location ? ` - ${curve.system ?? ""}${curve.location ?? ""}` : "") 
    else if (curve.key === "SET_POINT")
        name = t("SetPoint") + (curve.other ? ` - ${t("Other")}` : curve.identifier ? ` - ${curve.system} - ${curve.location} - ${curve.identifier.slice(-4)}` : curve.system || curve.location ? ` - ${curve.system ?? ""}${curve.location ?? ""}` : "") 
    else if (curve.key === "BATTERY_LEVEL") 
        name = curve.other ? `${t("Battery")} - ${t("Other")}` : `${t("Battery")} - ${curve.location} - ${curve.system} - ${curve.identifier.slice(-4)}` 
    else if (curve.key === "ENERGY_PRICE")
        name = `${t("EnergyPrice")} - ${curve.tariff_name}` 
    else if (curve.key === "CONSUMPTION_MONEY")
        name = t("ConsumptionCost")
    else if (curve.key === "CONSUMPTION_KWH")
        name = t("ConsumptionPower")
    else if (curve.key === "CARBON_INTENSITY")        
        name = t("CarbonIntensity")
    else if (curve.key === "POWER_METER")
        name = `${curve.location} - ${curve.system}`
    else if (curve.key === "GAS_METER")
        name = `${t("Gas meter")} - ${curve.location} - ${curve.system}` 
    else if (curve.key === "ELECTRICITY_CONSUMPTION")
        name = `${t("Consumption")} - ${curve.location} - ${curve.system}` 
    else if (curve.key === "COGENERATION")
        name = `${t("Cogeneration")} - ${curve.location} - ${curve.system}` 
    else if (curve.key === "SOLAR_PRODUCTION")
        name = `${t("Solar prod.")} - ${curve.location} - ${curve.system}` 
    else if (curve.key === "TRANSFORMER")
        name = `${t("Transformer")} - ${curve.location} - ${curve.system}` 
    else if (["APPARENT_POWER", "VOLTAGE", "CURRENT", "POWER_FACTOR"].includes(curve.key))
        name = `${curve.location} - ${curve.system}` 
    else if (curve.key === "OUTSIDE_TEMP")
        name = t("Temperature")
    else if (["CO2", "PRESSURE", "PM10", "PM2_5", "VOC", "HUMIDITY", "MOTION", "MODE", "ON_OFF", "FAN_SPEED"].includes(curve.key))
        name = `${curve.location} - ${curve.system} - ${curve.identifier.slice(-4)}`

    return name
}

export function getChartTitle(graphType, t, currencySymbol) {

    let title = t(graphType);
    if (["TEMPERATURE", "SET_POINT", "OUTSIDE_TEMP"].includes(graphType))
        title = t(graphType) + " [°C]";
    else if (graphType === "BATTERY_LEVEL")
        title = t(graphType) + " [%]";
    else if (["ENERGY_PRICE", "CONSUMPTION_MONEY"].includes(graphType))
        title = `${t(graphType)} [${currencySymbol}]`
    else if (graphType === "CONSUMPTION_KWH")
        title = `${t(graphType)} [kWh]`
    else if (["POWER_METER", "GAS_METER", "ELECTRICITY_CONSUMPTION", "SOLAR_PRODUCTION", "TRANSFORMER", "COGENERATION"].includes(graphType)) 
        title = `${t(graphType)} [kW]`
    else if (graphType === "CARBON_INTENSITY")
        title = `${t(graphType)} [g/kWh]`
    else if (graphType === "HUMIDITY")
        title = `${t(graphType)} [%]`
    else if (graphType === "PRESSURE")
        title = `${t(graphType)} [hPa]`
    else if (graphType === "CO2")
        title = `${t(graphType)} [ppm]`
    else if (graphType === "MOTION")  
        title = `${t(graphType)} [minutes]`
    else if (graphType === 'WEATHER')
        title = `${t(graphType)}`
    else if (graphType === 'APPARENT_POwER')
        title = `${t(graphType)} [kVA]`
    else if (graphType === 'VOLTAGE')
        title = `${t(graphType)} [V]`
    else if (graphType === 'CURRENT')
        title = `${t(graphType)} [A]`
    else if (graphType === 'POWER_FACTOR')
        title = `${t(graphType)}`
    else if (graphType === 'PM10')
        title = `${t(graphType)} [µg/m³]`
    else if (graphType === 'PM2_5')
        title = `${t(graphType)} [µg/m³]`
    else if (graphType === 'VOC')
        title = `${t(graphType)} [ppb]`
    return title
}